__turbopack_context__.v({
  "bar": "FanGrowthCard-module-scss-module__-vE0xG__bar",
  "barCol": "FanGrowthCard-module-scss-module__-vE0xG__barCol",
  "barHighlight": "FanGrowthCard-module-scss-module__-vE0xG__barHighlight",
  "barValue": "FanGrowthCard-module-scss-module__-vE0xG__barValue",
  "card": "FanGrowthCard-module-scss-module__-vE0xG__card",
  "chart": "FanGrowthCard-module-scss-module__-vE0xG__chart",
  "chartDense": "FanGrowthCard-module-scss-module__-vE0xG__chartDense",
  "comingSoonOverlay": "FanGrowthCard-module-scss-module__-vE0xG__comingSoonOverlay",
  "comingSoonText": "FanGrowthCard-module-scss-module__-vE0xG__comingSoonText",
  "content": "FanGrowthCard-module-scss-module__-vE0xG__content",
  "dayLabel": "FanGrowthCard-module-scss-module__-vE0xG__dayLabel",
  "header": "FanGrowthCard-module-scss-module__-vE0xG__header",
  "liveContent": "FanGrowthCard-module-scss-module__-vE0xG__liveContent",
  "monthLabel": "FanGrowthCard-module-scss-module__-vE0xG__monthLabel",
  "retry": "FanGrowthCard-module-scss-module__-vE0xG__retry",
  "segment": "FanGrowthCard-module-scss-module__-vE0xG__segment",
  "segmentActive": "FanGrowthCard-module-scss-module__-vE0xG__segmentActive",
  "segmentButton": "FanGrowthCard-module-scss-module__-vE0xG__segmentButton",
  "segments": "FanGrowthCard-module-scss-module__-vE0xG__segments",
  "slash": "FanGrowthCard-module-scss-module__-vE0xG__slash",
  "state": "FanGrowthCard-module-scss-module__-vE0xG__state",
  "stateText": "FanGrowthCard-module-scss-module__-vE0xG__stateText",
  "title": "FanGrowthCard-module-scss-module__-vE0xG__title",
});
